// extracted by mini-css-extract-plugin
module.exports = {"addBtnDisable":"_33kggi9gToq22YPVcurTQb","disableSvg":"_1a2hVpF9KmV6iGcpoiRyM6"};